import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  /** Rota fixa de destino. Se omitido, volta para a página anterior do histórico. */
  to?: string;
  label?: string;
  className?: string;
}

/**
 * Botão de voltar reutilizável. Sem `to`, usa o histórico (navigate(-1)).
 */
const BackButton: React.FC<BackButtonProps> = ({ to, label = 'Voltar', className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-2 text-sm font-medium text-secondary-600 hover:text-primary-600 transition-colors ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </button>
  );
};

export default BackButton;
